import React from 'react'

const MyTooltip = ({children,style,text}) => {
  if (!text || text?.length==0) return <>{children}</>
  return (

    <div className='my-tooltip'>
      <div className='tooltiptext' style={style}>
            {text}
        </div>
        {children}
    </div>
  )
}

export default MyTooltip